import { Button, Loading } from "@quark/design";
import { useEffect, useState } from "react";
import { getExamList } from "../../api";
import Footer from "../../component/footer";
import Navigator from "../../component/navigator";
import { ExamListItem } from "../../types/exam";
import ExamCard from "./card";
import styles from "./index.module.scss";
import useDocumentTitle from "../../hooks/use-document-title";

const ExamList = () => {
  useDocumentTitle("二级题库列表");
  const [list, setList] = useState<ExamListItem[]>([]);
  const [loadedIdMap, setLoadedIdMap] = useState<{ [id: number]: true }>({});
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasNext, setHasNext] = useState(false);

  const loadMore = () => {
    if (loading) {
      return;
    }
    setLoading(true);
    sessionStorage.setItem("scrollPosition", String(window.pageYOffset));
    getExamList({ page, page_size: 20 })
      .then(({ next, results }) => {
        setHasNext(!!next);
        // 去重，避免下一页含有上一页已加载的card
        const filterList = results.filter((r) => !loadedIdMap[r.id]);
        setList([...list, ...filterList]);
        const newLoadedIdMap = Object.assign(
          {},
          loadedIdMap,
          ...filterList.map((r) => ({ [r.id]: true }))
        );
        setLoadedIdMap(newLoadedIdMap);
        setPage(page + 1);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // const searchChange = (val: string) => {
  //   setSearch(val);
  //   setPage(1);
  //   setList([]);
  //   setLoadedIdMap({});
  // };

  useEffect(() => {
    const scrollPosition = sessionStorage.getItem("scrollPosition");
    if (scrollPosition) {
      window.scrollTo(0, parseInt(scrollPosition, 10));
      sessionStorage.removeItem("scrollPosition");
    }
  }, [list]);

  // useDebounceEffect(() => {
  //   loadMore();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [search]);

  useEffect(() => {
    loadMore();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className={styles.container}>
        <Navigator activeKey="exam" />
        <div className={styles.content}>
          {loading && <Loading style={{ height: "80vh" }} />}
          <div className={styles.cards}>
            {list.map((exam) => (
              <ExamCard dataSource={exam} key={exam.id} />
            ))}
            {!loading && hasNext && (
              <div className={styles["load-more"]}>
                <Button onClick={loadMore}>加载更多</Button>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ExamList;
